import $, { css, get } from "jquery";
import "@fancyapps/fancybox";
import Swiper from 'swiper/bundle';
import A11yDialog from 'a11y-dialog'
import smartWizard from 'smartwizard';
// import ResizeObserver from 'resize-observer-polyfill';
import SimpleBar from 'simplebar';
import "./menu";


$(function ($) {
    const simpleBarCategories = document.getElementById('categories');
    // const simpleBarBreadcrumbs = document.getElementById('breadcrumbs');

    // Check if the element exists
    if (simpleBarCategories) {
        // Make sure SimpleBar library is loaded
        if (typeof SimpleBar !== 'undefined') {
            new SimpleBar(simpleBarCategories, {
                autoHide: true,
                // Other options...
            });
        } else {
            console.error('SimpleBar library not loaded.');
        }
    }

    //   if (simpleBarBreadcrumbs) {
    //     // Make sure SimpleBar library is loaded
    //     if (typeof SimpleBar !== 'undefined') {
    //       new SimpleBar(simpleBarBreadcrumbs, {
    //         autoHide: true,
    //         // Other options...
    //       });
    //     } else {
    //       console.error('SimpleBar library not loaded.');
    //     }
    //   } 
    function validateEmail(email) {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(email);
    }

    $('.submit-email').on('click', function (e) {
        e.preventDefault();

        const emailValue = $('.add-email').val();

        if (validateEmail(emailValue)) {
            $('.submit-error').hide(); // Hide error message if previously shown
            // Perform actions like submitting the form or other tasks
            // For example:
            // $('.subscription').addClass('done');
        } else {
            $('.submit-error').show(); // Show error message for invalid email
            // You can also add CSS classes or other actions for error handling
        }
    });

    $('.add-email').on('input', function () {
        const emailValue = $(this).val();

        if (validateEmail(emailValue)) {
            $('.submit-error').hide(); // Hide error message if previously shown
        } else {
            $('.submit-error').show(); // Show error message for invalid email
        }
    });





    initializeAccordion();

    function checkWidth() {
        if ($(window).width() <= 768) {
            $('.categories').addClass('is--mobile');
        } else {
            $('.categories').removeClass('is--mobile');
        }
    }

    // Check width on page load
    checkWidth();

    // Check width on window resize
    $(window).resize(function () {
        checkWidth();
    });

    $(document).on('click', '.active .menu-item-has-children > a', function (e) {
        e.preventDefault();
        $(this).find('.sub-menu-arrow').toggleClass("rtoate180");
    });
    // Function to set the height of the explore-more block
    function setExploreMoreHeight() {
        const innerItemHeight = $('.list-item__wrap .inner-item').height();
        $('.list-item__wrap.explore-more .inner-item').height(innerItemHeight);
    }

    // Initial setup
    setExploreMoreHeight();

    // Recalculate and update the height when the window is resized
    $(window).on('resize', function () {
        setExploreMoreHeight();
    });

    $(".show-button").on('click', function () {
        var targetId = $(this).data("target");

        // Remove the "active" class from all buttons
        $(".show-button").removeClass("active");

        // Add the "active" class to the clicked button
        $(this).addClass("active");

        // Hide all blocks and remove the "show" class
        $(".block").hide().removeClass('show');

        // Show the block with the corresponding ID and apply display: flex
        $("#" + targetId).show().addClass('show').css('display', 'flex');
    });

    const carouselSwiper = new Swiper('.carousel-swiper', {
        loop: true,
        autoplay: {
            delay: 4000,
        },
        slidesPerView: 5,
        spaceBetween: 50,
        breakpoints: {
            1200: {
                slidesPerView: 5,
            },
            768: {
                slidesPerView: 4,
                spaceBetween: 30,
            },
            475: {
                slidesPerView: 3,
                spaceBetween: 15,
            },
            320: {
                slidesPerView: 2,
                spaceBetween: 15,
            }
        },
        // navigation: {
        //     nextEl: '.swiper-button-next.carousel-next',
        //     prevEl: '.swiper-button-prev.carousel-prev',
        //     clickable: true,
        // },
    });

    const realStorieslSwiper = new Swiper('.real-stories-container', {
        loop: true,
        // autoplay: {
        //     delay: 4000,
        // },
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 28,
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 30,
            }
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });

    /**
 * Initializes the accordion functionality.
 * This function hides all accordion contents, opens the specified accordion item from the hash fragment,
 * or opens the first accordion item by default if no hash is present.
 * It also handles click events on accordion items to toggle their visibility and scroll to the opened item.
 */
    function initializeAccordion() {
        // Hide all accordion contents initially
        $('.accordion .accordion-list > li > .accordion__content').hide();

        // Open the accordion item specified in the hash fragment
        const hash = window.location.hash;
        if (hash) {
            const accordionItemToOpen = $(hash);
            if (accordionItemToOpen.length) {
                accordionItemToOpen.addClass('active').find('.accordion__content').slideDown();
                // Scroll to the top of the opened accordion item
                $('html, body').animate({
                    scrollTop: accordionItemToOpen.offset().top - 92
                }, 500); // Adjust the scroll speed as needed
            }
        } else {
            // Open the first accordion item by default if no hash is present
            $('.accordion .accordion-list > li').first().addClass('active').find('.accordion__content').slideDown();
        }

        $('.accordion .accordion-list > li').on('click', function () {
            if ($(this).hasClass('active')) {
                $(this).removeClass('active').find('.accordion__content').slideUp();
            } else {
                $('.accordion-list > li.active .accordion__content').slideUp();
                $('.accordion-list > li.active').removeClass('active');
                $(this).addClass('active').find('.accordion__content').slideDown();
            }
            return false;
        });
    }

    function initializeModals() {
        $('.doctors [data-a11y-dialog-show]').on('click', function (e) {
            e.preventDefault();
            var dialogId = $(this).attr('data-a11y-dialog-show');
            $('#' + dialogId).attr('aria-hidden', 'false');

            // Hide body overflow when modal is opened
            $('body').css('overflow', 'hidden');
        });

        $('.doctors [data-a11y-dialog-hide]').on('click', function (e) {
            e.preventDefault();
            $(this).closest('.modal').attr('aria-hidden', 'true');

            // Restore body overflow when modal is closed
            $('body').css('overflow', 'auto');
        });
    }
    initializeModals();


    var page = 1;

    // AJAX function to filter posts by taxonomy and pagination
    function filterPosts(termSlug, pageNumber) {
        $.ajax({
            url: ajax_object.ajax_url,
            type: 'POST',
            data: {
                action: 'services_filter_posts',
                term_slug: termSlug,
                page: pageNumber,
            },
            success: function (response) {
                // Display filtered posts on the page
                $('.services-inner').html(response);

            },
        });
    }


    // Function to filter posts based on the term slug
    function filterPostsByTerm(termSlug) {
        $('.services-taxonomy-filter li').removeClass('active');
        $('.services-taxonomy-filter li').filter(function () {
            return $(this).data('tax-slug') === termSlug;
        }).addClass('active');

        filterPosts(termSlug, page);
    }

    // Function to handle click on service-term
    $('.service-terms.services-taxonomy-filter li.service-term').on('click', function () {
        var termSlug = $(this).data('tax-slug');

        // Check if body has a single-services class before filtering
        if ($('body').hasClass('single-services')) {
            filterPostsByTerm(termSlug);
        } else {
            // Redirect to services page with selected term as parameter
            window.location.href = 'http://nvelup.loc/services?term=' + termSlug;
        }
    });

    // Get the term parameter from the URL
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const selectedTermSlug = urlParams.get('term');

    // Trigger the AJAX function on taxonomy filter change

    $(document).on('click', '.services-taxonomy-filter li', function () {
        const termSlug = $(this).data('tax-slug');
        filterPosts(termSlug, page);

        // Remove 'active' class from all service terms and add to the clicked term
        $('.services-taxonomy-filter li').removeClass('active');
        $(this).addClass('active');

        // Remove the 'term' parameter from the URL and reload the page
        const currentURL = window.location.href;
        const updatedURL = currentURL.split('?')[0]; // Remove query parameters
        window.history.replaceState({}, document.title, updatedURL);
    });


    function handlePaginationClick() {
        $(document).on('click', '.services-section .pagination .page-numbers', function (e) {
            e.preventDefault();

            const page = $(this).text();
            const termSlug = $('.services-taxonomy-filter li.active').data('tax-slug');
            filterPosts(termSlug, page);

            // Remove 'current' class from all spans within pagination
            $('.services-section .pagination .page-numbers').removeClass('current');

            // Add 'current' class to the clicked span
            $(this).addClass('current');
        });
    }
    handlePaginationClick();

    // Click event handler for service terms
    $('.service-terms.services-taxonomy-filter li.service-term').on('click', function () {
        var termSlug = $(this).data('tax-slug');
        var pageNumber = 1; // Set your desired page number

        // Call the filterPosts function with the clicked termSlug
        filterPosts(termSlug, pageNumber);

        // Get the current domain and protocol dynamically
        const currentProtocol = window.location.protocol;
        const currentDomain = window.location.hostname;

        // Redirect to the services page with the selected term as a parameter using the current domain and protocol
        window.location.href = currentProtocol + '//' + currentDomain + '/services?term=' + termSlug;
    });


    // Function to load posts and pagination based on pre-selected taxonomy
    function loadPreSelectedPostsAndPagination() {
        const defaultPageNumber = 1;
        const url = window.location.href;
        // Check if the URL contains 'services'
        if (url.includes('services')) {
            // Find and add 'active' class to the list item with slug 'all'
            $('.services-taxonomy-filter li').filter(function () {
                return $(this).data('tax-slug') === 'all';
            }).addClass('active');

            // Load posts and pagination for the pre-selected taxonomy
            filterPosts('all', defaultPageNumber);
        }
    }
    if (window.location.href.includes('services') && selectedTermSlug) {
        filterPostsByTerm(selectedTermSlug);
    }
    // Check if the URL contains 'services' and no term parameter is present
    if (window.location.href.includes('services') && !selectedTermSlug) {
        loadPreSelectedPostsAndPagination();
    }
    // Initialize the main slider
    const mainSlider = new Swiper('.main-slider', {
        slidesPerView: 4,
        spaceBetween: 28,
        loop: true,
        autoplay: {
            delay: 4000,
        },
        breakpoints: {
            992: {
                slidesPerView: 4
            },
            700: {
                slidesPerView: 3
            },
            420: {
                slidesPerView: 2.5,
                spaceBetween: 15,
            },
            320: {
                slidesPerView: 2,
                spaceBetween: 15,
            }
        },
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
            dragSize: 105,
        }
    });

    const subSlider = new Swiper('.sub-slider', {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,

    });

    var isMainSliderChanging = false;
    var isSubSliderChanging = false;

    mainSlider.on('slideChange', function () {
        if (!isSubSliderChanging) {
            isMainSliderChanging = true;
            var activeSlideIndex = mainSlider.realIndex;
            subSlider.slideTo(activeSlideIndex);
        }
    });

    subSlider.on('slideChange', function () {
        if (!isMainSliderChanging) {
            isSubSliderChanging = true;
            var activeSlideIndex = subSlider.realIndex;
            mainSlider.slideToLoop(activeSlideIndex);

        }
    });

    subSlider.on('transitionEnd', function () {
        isSubSliderChanging = false;
    });

    mainSlider.on('transitionEnd', function () {
        isMainSliderChanging = false;
    });


    gsap.to(".animation-rotate", {
        duration: 6, // Animation duration in seconds
        rotation: 360, // Rotate 360 degrees
        ease: "linear", // Linear easing
        repeat: -1, // Repeat indefinitely
        repeatDelay: 0 // No delay between repeats
    });


    function addOverlayToElement($element) {
        $('.meet-our-providers__col .overlay').css('opacity', ''); // Reset opacity for all elements
        $element.find('.meet-our-providers__overlay').css('opacity', '1'); // Add overlay to the clicked element
    }

    if ($(window).width() < 992) {
        $('.meet-our-providers__col').on('click', function () {
            addOverlayToElement($(this));
        });
    }

    var collectedData = {};
    $('#smartwizard').smartWizard({
        autoAdjustHeight: false,
        enableUrlHash: false,
        showNavigation: false,
        keyboard: {
            keyNavigation: false, // Enable/Disable keyboard navigation(left and right keys are used if enabled)
            keyLeft: [37], // Left key code
            keyRight: [39], // Right key code
        },
        toolbar: {
            position: "none",
            showNextButton: false,
            showPreviousButton: false,
        }
    });


    let totalSteps = $('#smartwizard .nav li').length; // Replace with your total number of steps
    let currentStep = 1;
    let progress = 1; // Initial progress set to 1, considering the first step

    function updateProgressBar() {
        let calculatedWidth = 0;

        if (currentStep === 1) {
            calculatedWidth = (progress / totalSteps) * 100;
        } else {
            calculatedWidth = ((progress) / (totalSteps)) * 100; // Calculate progress, excluding initial step
        }
        $('.progress').css('width', `${calculatedWidth}%`);
    }

    // Initial progress bar setup (first step visually completed)
    updateProgressBar();
    function onbordingRadioClick() {

        $('.error-message').hide().text('');
    }
    $('.onbording-inner__answers .onbording-radio input[name="options' + currentStep + '"]').on('click', onbordingRadioClick);

    // Initialize an object to store collected data
    var collectedData = {};

    $('.next-btn').on('click', function () {
        // Get the H2 text from the current step
        var stepHeaderText = $('#step-' + currentStep + ' .onbording-inner__wrap h2').text().trim();
        // console.log('stepHeaderText' + stepHeaderText);
        // Get the value of the selected radio button
        var selectedRadioValue = $('input[name="options' + currentStep + '"]:checked').val();
        $('.onbording-inner__answers .onbording-radio input[name="options' + currentStep + '"]').on('click', onbordingRadioClick);
        // Check if a radio button is selected
        if ($('input[name="options' + currentStep + '"]:checked').length === 0) {
            // $('.onbording-inner__wrap #step-' + currentStep + ').show().text('Please choose one of the options.');
            $('.error-message').show().text('Please choose one of the options.');
        } else {
            // Hide the error message
            $('.error-message').hide().text('');

            $('.onbording-form .wpcf7-form input[name="heading_' + currentStep + '"]').val(stepHeaderText);
            $('.onbording-form .wpcf7-form input[name="option_' + currentStep + '"]').val(selectedRadioValue);


            // Proceed to the next step
            $('#smartwizard').smartWizard("next");

            // Update the step and progress variables
            if (currentStep < totalSteps) {
                currentStep++;
                progress++;
                updateProgressBar();
                // console.log(`Step ${currentStep} completed. Progress: ${progress - 1}/${totalSteps - 1}`);
            }
        }
    });

    $('.prev-btn').on('click', function () {
        $('#smartwizard').smartWizard("prev");
        if (currentStep > 1) {
            currentStep--;
            progress--;
            updateProgressBar();
            // console.log(`Moved back to Step ${currentStep}. Progress: ${progress - 1}/${totalSteps - 1}`);
        }
    });

    // Assuming your submit button has the ID "my-submit-button"
    var submitButton = $('.wpcf7-submit');

    // Trigger the form submission when another button is clicked
    $('.submit-button').on('click', function () {
        // Trigger the click event on the submit button
        submitButton.click();
    });
    function updateHiddenFieldsInContactForm7() {
        // Iterate over collectedData
        for (var stepNumber in collectedData) {
            if (collectedData.hasOwnProperty(stepNumber)) {
                var heading = collectedData[stepNumber].Heading;
                var selectedOption = collectedData[stepNumber].SelectedOption;

                // Update the corresponding hidden fields in Contact Form 7
                var hiddenHeadingField = $('.onbording-form .wpcf7-form input[name="collected_heading_' + stepNumber + '"]');
                var hiddenSelectedOptionField = $('.onbording-form .wpcf7-form input[name="collected_selected_option_' + stepNumber + '"]');

                // Update the values of the hidden fields
                hiddenHeadingField.val(heading);
                hiddenSelectedOptionField.val(selectedOption);
            }
        }
    }
    // Handle Contact Form 7 submit
    $('.onbording-form .wpcf7-form').on('submit', function () {
        // Update the hidden fields with collected data
        updateHiddenFieldsInContactForm7();

        // Perform any additional actions before the form submission if needed
        // console.log("Contact Form 7 is being submitted with collected data:", collectedData);
        return true; // Allow the form submission to continue
    });


    var color = $('.carousel-swiper img').css('background-color', 'transparent'); //getting color after document loaded

    function initializeDialog(dialogId) {
        var dialogEl = document.getElementById(dialogId);
        var dialog = new A11yDialog(dialogEl);

        $(dialogEl).on('show', function (event) {
            const container = event.target;

            // Check if the event is triggered programmatically via `.show(..)`
            // or via a UI interaction
            if (event.detail && event.detail.target) {
                const target = event.detail.target;
                const opener = $(target).closest('[data-a11y-dialog-show]');
                $('body').css('overflow', 'hidden');
                $(container).addClass('dialog-open');
                // console.log(container, target, opener);
                // Add overflow: hidden to the body when the dialog is shown
                // Apply animation to show the dialog window

            }
        });

        // If you have multiple dialog openers, you can bind the event handler like this:
        // $('.get-started').on('click', function (event) {
        //     event.preventDefault();
        //     var targetDialog = $(this).attr('data-a11y-dialog-show');
        //     dialog.show('#' + targetDialog);
        // });

        // Ensure to remove the animation class when the dialog is closed
        dialogEl.addEventListener('hide', function (event) {
            $('body').css('overflow', 'auto');
            // Remove animation class when hiding the dialog window
            $(dialogEl).removeClass('dialog-open');
        });

        // Add CSS to enable scrolling when necessary
        dialogEl.style.overflowY = 'auto';
        // dialogEl.style.maxHeight = '80vh';
    }

    // Call the function with the specific dialog ID
    initializeDialog('nvelup-dialog');
    initializeDialog('nvelup-dialog-for-you');


    var $categories = $('.category #categories');
    if ($categories) {
        if ($categories.length) {
            $('html, body').animate({
                scrollTop: $categories.offset().top
            }, 'slow');
        }
    }


    // Function to handle smooth scrolling
    function scrollToSection(targetId) {
        var targetOffset = $(targetId).offset().top;
        $('html, body').animate({
            scrollTop: targetOffset
        }, 'slow');
    }
    if (window.location.hash) {
        scrollToSection(window.location.hash);
    }
    // Smooth scroll to section on menu item click
    $('.menu-click-scroll a[href*="#"]').on('click', function (e) {
        e.preventDefault();
        // $(document).off("scroll");
        const targetId = this.hash;
        const $targetId = $(targetId);
        // scrollToSection($targetId);
        // Because we are redefining how it should behave...

        if (this.pathname === window.location.pathname) {
            // ...that is to scroll to a section of the page
            // IF we are on the intended page
            scrollToSection(this.hash);
        } else {
            // Remove the hash from the URL before redirecting

            window.location.replace(this.href);

        }
    });
});
